module.exports = __webpack_public_path__ + "img/bear.7e1ff988.png";